import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=f9a313ac&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9a313ac')) {
      api.createRecord('f9a313ac', component.options)
    } else {
      api.reload('f9a313ac', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=f9a313ac&", function () {
      api.rerender('f9a313ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24d3Wi1Kovvmu/JS/videoIframe.vue"
export default component.exports